module.exports = __webpack_public_path__ + "img/filter-exchange.fc103e34.svg";